import QuizMixin from '@/mixins/quiz';

export default {
  props: {
    content: {
      type    : Object,
      default : () => ({})
    }
  },
  mixins: [QuizMixin],
  data() {
    return {
      validAttempt: {}
    };
  },
  created() {
    this.getValidAttempt();
  },
  updated() {
    this.getValidAttempt();
  },
  methods: {
    openAttemptSummaryModal(attempt) {
      this.$emit('open-summary-modal', attempt);
    },
    getValidAttempt() {
      this.validAttempt = this.content.attempts.filter(a => a.attemptId === this.content.enrollmentQuizAttemptId)[0];
    },
    getPercentage(grade, total) {
      return (Number(grade) / Number(total)) * 100;
    }
  }
};
